/*
	User
*/
export const RETRIEVE_USER_FROM_LOCAL_STORAGE =
  'RETRIEVE_USER_FROM_LOCAL_STORAGE';

/*
	Authenticate
*/
export const SET_IDS = 'SET_IDS';
export const SET_AUTH_FIELD = 'SET_AUTH_FIELD';
export const TOGGLE_MEMORIZE_IDS = 'TOGGLE_MEMORIZE_IDS';
export const TOGGLE_AUTHENTICATE_MODAL = 'TOGGLE_AUTHENTICATE_MODAL';
export const TOGGLE_AUTHENTICATE_ERROR = 'TOGGLE_SHOW_AUTHENTICATE_ERROR';
export const AUTHENTICATE_REQUEST = 'AUTHENTICATE_REQUEST';
export const AUTHENTICATE_FAIL = 'AUTHENTICATE_FAIL';
export const AUTHENTICATE_SUCCESS = 'AUTHENTICATE_SUCCESS';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_FAIL = 'LOGOUT_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

/*
	Project
*/
export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_FAIL = 'GET_PROJECTS_FAIL';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';

export const SELECT_PROJECT = 'SELECT_PROJECT';
export const TOGGLE_SHOW_STARTED_PROJECTS = 'TOGGLE_SHOW_STARTED_PROJECTS';
export const TOGGLE_SHOW_CLOSED_PROJECTS = 'TOGGLE_SHOW_CLOSED_PROJECTS';

export const CREATE_NEW_PROJECT = 'CREATE_NEW_PROJECT';
export const EDIT_EXISTING_PROJECT = 'EDIT_EXISTING_PROJECT';

export const SAVE_PROJECT_REQUEST = 'SAVE_PROJECT_REQUEST';
export const SAVE_PROJECT_SUCCESS = 'SAVE_PROJECT_SUCCESS';
export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_FAIL = 'DELETE_PROJECT_FAIL';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const CANCEL_PROJECT_FORM = 'CANCEL_PROJECT_FORM';
export const CREATE_PROJECT = 'CREATE_PROJECT';
export const UPDATE_PROJECT = 'UPDATE_PROJECT';
export const SET_PROJECT = 'SET_PROJECT';
export const SET_PROJECT_NAME = 'SET_PROJECT_NAME';
export const SET_PROJECT_CITY = 'SET_PROJECT_CITY';
export const SET_PROJECT_DATE_OF_RECEIPT = 'SET_PROJECT_DATE_OF_RECEIPT';
export const SET_PROJECT_EMAIL = 'SET_PROJECT_EMAIL';
export const SET_PROJECT_COMMENT = 'SET_PROJECT_COMMENT';
export const SET_SURFACE_TREATMENT_CODE = 'SET_SURFACE_TREATMENT_CODE';
export const SET_IS_PROTECTED = 'SET_IS_PROTECTED';
export const SET_A2P = 'SET_A2P';
export const SET_PROJECT_TYPE_ID = 'SET_PROJECT_TYPE_ID';

/*
	Clone
*/
export const GET_PROJECT_REQUEST = 'GET_PROJECT_REQUEST';
export const GET_PROJECT_FAIL = 'GET_PROJECT_FAIL';
export const GET_PROJECT_SUCCESS = 'GET_PROJECT_SUCCESS';

export const CLONE_PROJECT_TEMPLATE_REQUEST = 'CLONE_PROJECT_TEMPLATE_REQUEST';
export const CLONE_PROJECT_TEMPLATE_FAIL = 'CLONE_PROJECT_TEMPLATE_FAIL';
export const CLONE_PROJECT_TEMPLATE_SUCCESS = 'CLONE_PROJECT_TEMPLATE_SUCCESS';

/*
	Matrix
*/
export const GET_LOCKINGS_REQUEST = 'GET_LOCKINGS_REQUEST';
export const GET_LOCKINGS_FAIL = 'GET_LOCKINGS_FAIL';
export const GET_LOCKINGS_SUCCESS = 'GET_LOCKINGS_SUCCESS';
export const GET_CYLINDERS_TYPES_REQUEST = 'GET_CYLINDERS_TYPES_REQUEST';
export const GET_CYLINDERS_TYPES_FAIL = 'GET_CYLINDERS_TYPES_FAIL';
export const GET_CYLINDERS_TYPES_SUCCESS = 'GET_CYLINDERS_TYPES_SUCCESS';
export const SAVE_LOCKING_REQUEST = 'SAVE_LOCKING_REQUEST';
export const SAVE_LOCKING_FAIL = 'SAVE_LOCKING_FAIL';
export const SAVE_LOCKING_SUCCESS = 'SAVE_LOCKING_SUCCESS';
export const DUPLICATE_LOCKING_REQUEST = 'DUPLICATE_LOCKING_REQUEST';
export const DUPLICATE_LOCKING_FAIL = 'DUPLICATE_LOCKING_FAIL';
export const DUPLICATE_LOCKING_SUCCESS = 'DUPLICATE_LOCKING_SUCCESS';
export const SAVE_GROUP_REQUEST = 'SAVE_GROUP_REQUEST';
export const SAVE_GROUP_FAIL = 'SAVE_GROUP_FAIL';
export const SAVE_GROUP_SUCCESS = 'SAVE_GROUP_SUCCESS';
export const DELETE_LOCKING_REQUEST = 'DELETE_LOCKING_REQUEST';
export const DELETE_LOCKING_FAIL = 'DELETE_LOCKING_FAIL';
export const DELETE_LOCKING_SUCCESS = 'DELETE_LOCKING_SUCCESS';
export const CLONE_LOCKING_REQUEST = 'CLONE_LOCKING_REQUEST';
export const CLONE_LOCKING_FAIL = 'CLONE_LOCKING_FAIL';
export const CLONE_LOCKING_SUCCESS = 'CLONE_LOCKING_SUCCESS';
export const SELECT_LOCKING = 'SELECT_LOCKING';
export const TOGGLE_LOCKING_LIST_ACTIONS = 'TOGGLE_LOCKING_LIST_ACTIONS';
export const TOGGLE_LOCKING_CHILDREN = 'TOGGLE_LOCKING_CHILDREN';
export const TOGGLE_LOCKING_FORM = 'TOGGLE_LOCKING_FORM';
export const TOGGLE_GROUP_FORM = 'TOGGLE_GROUP_FORM';
export const SET_CYLINDER_TYPE_ID = 'SET_CYLINDER_TYPE_ID';
export const SET_DISENGAGEABLE = 'SET_DISENGAGEABLE';
export const SET_DIMENSION_A = 'SET_DIMENSION_A';
export const SET_DIMENSION_B = 'SET_DIMENSION_B';
export const SET_LOCKING_FORM_FIELD = 'SET_LOCKING_FORM_FIELD';
export const SET_GROUP_FORM_FIELD = 'SET_GROUP_FORM_FIELD';
export const TOGGLE_TOP_PLACEHOLDER = 'TOGGLE_TOP_PLACEHOLDER';
export const TOGGLE_BOTTOM_PLACEHOLDER = 'TOGGLE_BOTTOM_PLACEHOLDER';
export const TOGGLE_ALL_PLACEHOLDER = 'TOGGLE_ALL_PLACEHOLDER';
export const MOVE_LOCKING_REQUEST = 'MOVE_LOCKING_REQUEST';
export const MOVE_LOCKING_FAIL = 'MOVE_LOCKING_FAIL';
export const MOVE_LOCKING_SUCCESS = 'MOVE_LOCKING_SUCCESS';
export const TOGGLE_CLONE_LOCKING_FORM = 'TOGGLE_CLONE_LOCKING_FORM';
export const TOGGLE_DELETE_LOCKING_CONFIRM = 'TOGGLE_DELETE_LOCKING_CONFIRM';
export const MOVE_LOCKING = 'MOVE_LOCKING';
// export const COLLAPSE_GROUP						= "COLLAPSE_GROUP";
// export const EXPAND_GROUP						= "EXPAND_GROUP";
export const TOGGLE_GROUP = 'TOGGLE_GROUP';

export const NEW_ROLE = 'NEW_ROLE';
export const CLOSE_ROLE_FORM = 'CLOSE_ROLE_FORM';
export const ROLE_CLICK = 'ROLE_CLICK';

export const NEW_LOCKING = 'NEW_LOCKING';
export const NEW_GROUP = 'NEW_GROUP';
export const LOCKING_CLICK = 'LOCKING_CLICK';
export const CLOSE_LOCKING_FORM = 'CLOSE_LOCKING_FORM';

/*
	Role
*/
export const SELECT_ROLE = 'SELECT_ROLE';
export const UNSELECT_ROLE = 'UNSELECT_ROLE';
export const CREATE_NEW_ROLE = 'CREATE_NEW_ROLE';
export const SET_ROLE_NAME_FIELD = 'SET_ROLE_NAME_FIELD';
export const SET_ROLE_NUMBER_OF_KEYS_FIELD = 'SET_ROLE_NUMBER_OF_KEYS_FIELD';
export const GET_ROLES_REQUEST = 'GET_ROLE_REQUEST';
export const GET_ROLES_FAIL = 'GET_ROLE_FAIL';
export const GET_ROLES_SUCCESS = 'GET_ROLE_SUCCESS';
export const SAVE_ROLE_REQUEST = 'SAVE_ROLE_REQUEST';
export const SAVE_ROLE_FAIL = 'SAVE_ROLE_FAIL';
export const SAVE_ROLE_SUCCESS = 'SAVE_ROLE_SUCCESS';
export const DUPLICATE_ROLE_REQUEST = 'DUPLICATE_ROLE_REQUEST';
export const DUPLICATE_ROLE_FAIL = 'DUPLICATE_ROLE_FAIL';
export const DUPLICATE_ROLE_SUCCESS = 'DUPLICATE_ROLE_SUCCESS';
export const DELETE_ROLE_REQUEST = 'DELETE_ROLE_REQUEST';
export const DELETE_ROLE_FAIL = 'DELETE_ROLE_FAIL';
export const DELETE_ROLE_SUCCESS = 'DELETE_ROLE_SUCCESS';
export const TOGGLE_DELETE_ROLE_CONFIRM = 'TOGGLE_DELETE_ROLE_CONFIRM';
export const TOGGLE_ROLE_FORM = 'TOGGLE_ROLE_FORM';
export const TOGGLE_DUPLICATE_ROLE_FORM = 'TOGGLE_DUPLICATE_ROLE_FORM';

/*
	Right
*/
export const ADD_RIGHT_REQUEST = 'ADD_RIGHT_REQUEST';
export const ADD_RIGHT_FAIL = 'ADD_RIGHT_FAIL';
export const ADD_RIGHT_SUCCESS = 'ADD_RIGHT_SUCCESS';
export const DELETE_RIGHT_REQUEST = 'DELETE_RIGHT_REQUEST';
export const DELETE_RIGHT_FAIL = 'DELETE_RIGHT_FAIL';
export const DELETE_RIGHT_SUCCESS = 'DELETE_RIGHT_SUCCESS';
export const TOGGLE_OPEN_ALL_LOCKINGS = 'TOGGLE_OPEN_ALL_LOCKINGS';
export const TOGGLE_ALL_ROLES = 'TOGGLE_ALL_ROLES';

/*
	INSCRIPTION
*/
export const SET_INSCRIPTION_FILED = 'SET_INSCRIPTION_FILED';
export const SUBSCRIBE_REQUEST = 'SUBSCRIBE_REQUEST';
export const SUBSCRIBE_FAIL = 'SUBSCRIBE_FAIL';
export const SUBSCRIBE_SUCCESS = 'SUBSCRIBE_SUCCESS';

/*
	OFFER
*/
export const GET_OFFER_REQUEST = 'GET_OFFER_REQUEST';
export const GET_OFFER_FAIL = 'GET_OFFER_FAIL';
export const GET_OFFER_SUCCESS = 'GET_OFFER_SUCCESS';
export const FILTER_BY_BRAND = 'FILTER_BY_BRAND';
export const FILTER_BY_A2P = 'FILTER_BY_A2P';
export const FILTER_BY_PROTECTED = 'FILTER_BY_PROTECTED';

export const GET_QUOTATION_REQUEST = 'GET_QUOTATION_REQUEST';
export const GET_QUOTATION_FAIL = 'GET_QUOTATION_FAIL';
export const GET_QUOTATION_SUCCESS = 'GET_QUOTATION_SUCCESS';

/*
	ERROR
*/
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const ERROR = 'ERROR';
export const RESET_ERROR = 'RESET_ERROR';



// WEBPACK FOOTER //
// ./src/js/app/ActionTypes.js